import React from "react";
import PulseSelect from "./Select/PulseSelect";

import { LinearProgress } from "@material-ui/core";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import useQueryBuilder from "qpr-base/querybuilder/useQueryBuilder";
import { useTranslation } from "react-i18next";
import { TOption } from "./types";
const PickAttribute = (props: {
  id: string;
  value?: TOption;
  onChange?: (value: TOption) => void;
}) => {
  const { t } = useTranslation();
  const ctx = useAppContext();
  const [selectedAttribute, setSelectedAttribute] = React.useState<
    TOption | undefined
  >(props.value);
  const uniqueKeyIdentifier = "3d85ff03a8";
  // strips the option from the unique str
  const getPureOption = (option: TOption) => {
    const idx = option.value.indexOf(uniqueKeyIdentifier);
    const newVal = { ...option, value: option.value.substring(0, idx) };
    return newVal;
  };
  const { data, isLoading } = useQueryBuilder<
    { name: string; attributes: string }[]
  >((q) =>
    q(props.id).attributes("name", [
      "value",
      { series: "JS_ATTR", period: "latestforseries", as: "attributes" },
    ])
  );

  const attributeList = React.useMemo(() => {
    if (data && !isLoading) {
      const attrs = JSON.parse(data?.data[0].attributes || "{}") as any;
      const keys = Object.keys(
        attrs?.["Localized-Text-Attributes"]?.["en"] || {}
      );
      const options: TOption[] = [];
      /* eslint-disable */
      for (const key of keys) {
        const value = t(attrs["Localized-Text-Attributes"][ctx.language][key]);
        const uniqueStr = `${uniqueKeyIdentifier}${key}`;
        options.push({
          label: `${t(key)} ${value === "" ? `(${t("configtypes.No data")})` : ""}`,
          value: `${value}${uniqueStr}`,
        });
      }
      return options;
      /* eslint-enable */
    }
    return [];
  }, [data, isLoading]);

  if (isLoading) {
    return (
      <div
        style={{ width: "100%", height: "2px", padding: "20px 0px 20px 0px" }}
      >
        <LinearProgress />
      </div>
    );
  }
  return (
    <PulseSelect
      name="name"
      placeholder={`${t("myStories.Select")}...`}
      isSearchable={false}
      label={t("myStories.Select attribute")}
      onChange={(e) => {
        setSelectedAttribute(e);
        if (props.onChange) {
          props.onChange(getPureOption(e));
        }
      }}
      options={attributeList}
      value={selectedAttribute}
      isOptionDisabled={(option: TOption, selectValue) =>
        getPureOption(option).value === ""
      }
    />
  );
};

export default PickAttribute;
